export default __webpack_public_path__ + "static/media/AG_Helvetica.2c55cecf.woff";